import React from "react";
import { Link } from "react-router-dom";

const BreadCrumb = () => {
  return (
    <>
      <div className="bredcum_area">
        <div className="container">
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="#">Home</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/challenges">Challenge</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Challenge Details
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </>
  );
};

export default BreadCrumb;
